import React, { useState, useEffect } from "react";
import '../../Checkout.css';
import axios from 'axios';
import { env } from "../../env";
import LoaderComp from '../LoaderComp';
import CheckoutCardPayment from '../Http/CheckoutCardPayment';
import OrderReviewSuccess from "./OrderReviewSuccess";
import { properties } from "../../properties";

const CheckoutPayment = ({ checkoutParam }) => {
  const baseURL = env.REACT_APP_BACKEND_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [url, setUrl] = useState();
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [showPayPal, setShowPayPal] = useState(false);
  const [successResponse, setSuccessResponse] = useState();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const [updateResText, setUpdateResText] = useState('');
  const [cardBillingAddress, setCardBillingAddress] = useState({
    card_billingaddress_country: "",
    card_billingaddress_addressLine1: "",
    card_billingaddress_addressLine2: "",
    card_billingaddress_city: "",
    card_billingaddress_state: "",
    card_billingaddress_phone: "",
    card_billingaddress_postCode: ""
  });
  const [canSubmit, setCanSubmit] = useState(false);
  const [updateAmountVal, setUpdateAmountVal] = useState();
  var countries = [];

  const initPaymentProviderClient = (provider) => {
    const paymentFactory = new window.PaymentFactory();
    paymentFactory.init({
      appId: checkoutParam.appId,
      region: checkoutParam.region,
      currency: checkoutParam.presentmentCurrency,
      amount: checkoutParam.amount,
      intentType: checkoutParam.intentType,
      timestamp: checkoutParam.timestamp,
      email: checkoutParam.email,
      paymentToken: checkoutParam.paymentToken,
      paymentMethods: checkoutParam.payments,
      paymentReference: checkoutParam.paymentReference,
      locale: checkoutParam.locale,
      countryCode: checkoutParam.countryCode,
      isTestMode: checkoutParam.isPayPalTestMode,
      fakeNonce: checkoutParam.payPalFakeNonce,
      captchaRetryAttempt: checkoutParam.captchaRetryAttempt,
      declineRateLimit: checkoutParam.declineRateLimit,
      isCaptchaTestMode: checkoutParam.isCaptchaTestMode,
      captchaSiteKey: checkoutParam.captchaSiteKey,
      captchaTestDescription: checkoutParam.captchaTestDescription,
      successCallback: (response) => {
        const bankDebitProviders = [properties.ACHProvider, properties.BacsProvider, properties.BecsProvider];
        console.log("successCallback response");
        console.log(response);
        let element;
        let errorResponseDiv = document.getElementById("error-response-div");
        errorResponseDiv.innerHTML = "";
        if (provider === properties.PayPalProvider) {
          element = document.getElementById('paypal-button');
        }
        else if (provider === properties.CreditCardProvider) {
          if (document.getElementById("address-controller")) {
            document.getElementById("address-controller").style.display = "none";
          }
          element = document.getElementById('payment-element');
          document.getElementById("card_billingaddress_city").value = "";
          document.getElementById("card_billingaddress_country").value = "";
          document.getElementById("card_billingaddress_addressLine1").value = "";
          document.getElementById("card_billingaddress_addressLine2").value = "";
          document.getElementById("card_billingaddress_postCode").value = "";
          document.getElementById("card_billingaddress_state").value = "";
          document.getElementById("card_billingaddress_phone").value = "";
          document.getElementById("cardBillingAddress").style.display = "none";
        }
        else if (provider === properties.ACHProvider) {
          element = document.getElementById('us_bank_account');
        }
        // else if (provider === properties.WalletProvider) {
        //   element = document.getElementById('payment-request-button');
        // }
        else if (provider === properties.ExpressElementProvider) {
          element = document.getElementById('express-element');
        }
        else if (provider === properties.BacsProvider) {
          element = document.getElementById('bacs_debit');
        }
        else if (provider === properties.BecsProvider) {
          element = document.getElementById('au_becs_debit');
        }
        if (provider !== properties.CreditCardProvider) {
          element.innerHTML = "";
        }

        var textedJson = JSON.stringify((response), undefined, 4);
        if (response.returnCode === '0' || ((bankDebitProviders.includes(provider)) && (response.returnCode === '8' || response.returnCode === '9'))) {
          disablePaymentMethodRadioButton();
          if (document.getElementById("errMg")) {
            document.getElementById("errMg").remove();
          }
          element.innerHTML = '<div style="padding:20px;"><h3 style="color:green;">Thank you for your payment!</h3><div><div><textarea readonly id="responseTextarea" spellcheck="false" style="width:100%;height:150px;">' + textedJson + '</textarea></div></div></div>';
        }
        else {
          let errMsg;
          if (document.getElementById("errMg")) {
            document.getElementById("errMg").remove();
          }
          errMsg = document.createElement("div");
          errMsg.id = "errMg";
          errMsg.innerHTML = '<div style="padding:20px;"><h3 style="color:red;">Oops! Your payment failed.</h3><div><div><textarea readonly id="responseTextarea" spellcheck="false" style="width:100%;height:150px;">' + textedJson + '</textarea></div></div></div>';
          element.parentNode.prepend(errMsg);
          // element.innerHTML = '<div style="padding:20px;"><h3 style="color:red;">Oops! Your payment failed.</h3><div><div><textarea id="responseTextarea" spellcheck="false" style="width:100%;height:150px;">' + textedJson + '</textarea></div></div></div>';
        }
      },
      errorCallback: (error) => {
        console.log("errorCallback response");
        console.log(error);
        let element = document.getElementById("error-response-div");
        // if (provider === properties.ACHProvider && !error.message) {
        //   element = document.getElementById('us_bank_account');
        // } else if (provider === properties.BacsProvider && !error.message) {
        //   element = document.getElementById('bacs_debit');
        // }
        // if (provider === properties.PayPalProvider) {
        //   element = document.getElementById('paypal-button');
        // }
        // else if (provider === properties.CreditCardProvider) {
        //   element = document.getElementById('payment-element');
        // }
        // else if (provider === properties.WalletProvider) {
        //   element = document.getElementById('payment-request-button');
        // }
        // else if (provider === properties.ExpressElementProvider) {
        //   element = document.getElementById('express-element');
        // }
        var textedJson = JSON.stringify((error), undefined, 4);
        element.innerHTML = "";
        if (element.classList.contains("hide")) {
          element.classList.remove("hide");
          if (document.getElementById("errMg")) {
            document.getElementById("errMg").remove();
          }
        }
        element.innerHTML = '<div style="padding:20px;"><h3 style="color:red;">Oops! Your payment failed.</h3><div><div><textarea readonly id="responseTextarea" spellcheck="false" style="width:100%;height:150px;">' + textedJson + '</textarea></div></div></div>';
      }
    }, provider)
  }
  const onPaymentMethodChange = (event) => {
    console.log('inside onPaymentMethodChange function');
    let element = document.getElementById("error-response-div");
    element.innerHTML = "";
    setSelectedPaymentMethod(event.target.value);
    const paymentSectionId = event.target.value + "Section";
    // const paymentSection = ["PayPalSection", "CardSection", "WalletSection", "ExpressElementSection"];
    const paymentSection = ["PayPalSection", "CardSection", "ExpressElementSection", "ACHSection", "BACSSection", "BECSSection"];
    paymentSection.forEach((section) => {
      if (section === paymentSectionId) {
        document.getElementById(section).style.display = 'block';
      }
      else {
        document.getElementById(section).style.display = 'none';
      }
    });
    document.getElementById('paypal-button').innerHTML = "";
    document.getElementById('payment-element').innerHTML = "";
    document.getElementById('us_bank_account').innerHTML = "";
    // document.getElementById('payment-request-button').innerHTML = "";
    document.getElementById('express-element').innerHTML = "";
    document.getElementById('bacs_debit').innerHTML = "";
    document.getElementById('au_becs_debit').innerHTML = "";
    // disablePaymentMethodRadioButton();
    initPaymentProviderClient(event.target.value);
  }

  const disablePaymentMethodRadioButton = () => {
    let inputs = document.getElementsByName('radioPaymentMethod');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].disabled = true;
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) {
      checkoutParam.isEmbedded = true;
    }
    else {
      checkoutParam.isEmbedded = false;
    }
    if(checkoutParam.intentType === properties.INTENTTYPE.SAVE_CARD){
      delete checkoutParam.amount;
    }
    if (checkoutParam.isPayPalTestMode === "Yes" || checkoutParam.isPayPalTestMode === true) {
      checkoutParam.isPayPalTestMode = true;
    }
    else {
      checkoutParam.isPayPalTestMode = false;
    }

    if (checkoutParam.isCaptchaTestMode === "Yes" || checkoutParam.isCaptchaTestMode === true) {
      checkoutParam.isCaptchaTestMode = true;
    }
    else {
      checkoutParam.isCaptchaTestMode = false;
    }

    checkoutParam.timestamp = (Math.floor(Date.now() / 1000)).toString();
    axios.post(baseURL + '/testclient/paynow', checkoutParam)
      .then(res => {
        console.log(res.data);
        setUrl(res.data.referenceUrl);
        checkoutParam.paymentToken = res.data.paymentToken;
        checkoutParam.paymentReference = res.data.paymentReference;
        setIsLoading(false);
        if (res.data.redirect) {
          window.location.href = res.data.referenceUrl;
        }
        else {
          setShowPaymentMethod(true);
          if (res.data.paymentToken) {
            setShowPayPal(true);
          }
        }
      })

      .catch((err) => {
        setErrorMsg(JSON.stringify(err.response.data, undefined, 4));
        setIsLoading(false);
      });
  };

  function isNotNullCheck(e, field) {
    if (e === "" || !e) {
      document.getElementsByName(field)[0].classList.add("emptied");
      document.getElementsByName(field)[1].classList.add("emptied");
      setCanSubmit(false);
    }
    else {
      document.getElementsByName(field)[0].classList.remove("emptied");
      document.getElementsByName(field)[1].classList.remove("emptied");
    }
    const card_billingaddress_city = document.getElementById("card_billingaddress_city").value;
    const card_billingaddress_country = document.getElementById("card_billingaddress_country").value;
    const card_billingaddress_addressLine1 = document.getElementById("card_billingaddress_addressLine1").value;
    const card_billingaddress_postCode = document.getElementById("card_billingaddress_postCode").value;
    const card_billingaddress_phone = document.getElementById("card_billingaddress_phone").value;

    if (card_billingaddress_country && card_billingaddress_addressLine1 && card_billingaddress_postCode && card_billingaddress_city && card_billingaddress_phone && window.captchaCardValid) {
      setCanSubmit(true);
    }
    else {
      setCanSubmit(false);
    }
  }

  function changeBillingCountry(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_country: e.target.value });
  }

  function changeAddressLine1(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_addressLine1: e.target.value });
  }

  function changeAddressLine2(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_addressLine2: e.target.value });
  }

  function changeZip(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_postCode: e.target.value });
  }

  function changeCity(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_city: e.target.value });
  }

  function changeState(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_state: e.target.value });
  }

  function changePhone(e) {
    setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_phone: e.target.value });
  }

  function changeAmount(event) {
    setUpdateAmountVal(event.target.value);
  }

  function updateAmount() {
    checkoutParam.amount = Number(updateAmountVal);
    const inputParam = {
      paymentReference: checkoutParam.paymentReference,
      amount: checkoutParam.amount
    }
    axios.post(baseURL + '/testclient/paynow/update', inputParam)
      .then(res => {
        if (res.status == 200) {
          setUpdateResText("Amount updated");
          checkoutParam.paymentToken = res.data.paymentToken;
        } else {
          setUpdateResText("Amount not updated");
        }
      })
  }

  function submitCardPayment(e) {
    e.preventDefault();
    isNotNullCheck(cardBillingAddress.card_billingaddress_country, "card_billingaddress_country");
    isNotNullCheck(cardBillingAddress.card_billingaddress_addressLine1, "card_billingaddress_addressLine1");
    isNotNullCheck(cardBillingAddress.card_billingaddress_postCode, "card_billingaddress_postCode");
    isNotNullCheck(cardBillingAddress.card_billingaddress_city, "card_billingaddress_city");
    isNotNullCheck(cardBillingAddress.card_billingaddress_phone, "card_billingaddress_phone");
  }

  properties.COUNTRY_LIST.forEach((property) => {
    countries.push(<option value={property.code} key={property.code}>{property.name}</option>);
  });

  useEffect(() => {
    setUpdateAmountVal(checkoutParam.amount);
    const onMessage = (event) => {
      if (event.data.returnCode) {
        setSuccessResponse(event.data);
        setShowSuccessPage(true);
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    }
  }, []);

  const showBillingAddressHandler = (event) => {
    if (event.target.checked) {
      document.getElementById("cardBillingAddress").classList.add("hide");
    } else {
      document.getElementById("cardBillingAddress").classList.remove("hide");
    }
  }

  return (
    <div>
      {showSuccessPage ? (<OrderReviewSuccess successResponse={successResponse} checkoutParam={checkoutParam} />) : (
        <div>
          <div className="checkout-payment">
            <h2>Checkout</h2>
            <div className="row">
              <div className="detail">
                {(checkoutParam.intentType === properties.INTENTTYPE.SAVE_CARD) ? (
                  <div className={`${showPaymentMethod ? "saveCard top" : "saveCard"}`}>
                    <p>Your card details will be saved.</p>
                    {!showPaymentMethod && (
                      <>
                        <button className="btn btn-primary w-auto" onClick={handleSubmit}>Proceed</button>
                        {errorMsg && (
                          <div className="order-row">
                            <div className="order-col">
                              <textarea id="errMsgextarea" spellCheck="false" style={{ width: "400px", height: "150px", margin: "10px" }} value={errorMsg} readOnly={true}></textarea>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div id="error-response-div"></div>
                  </div>
                ) :
                  (
                    <>
                      <div className={`${showPaymentMethod ? "bookDetailRight" : "bookDetailRow"}`}>
                        {/* <div className="book-detail">
                          <div className="book-detail-left">
                            <img src="../../book.jpg" alt="book"></img>
                          </div>
                          <div className="book-detail-right">
                            <div className="book-title mb-10">Statistics for Terrified Biologists, 2nd Edition</div>
                            <div className="book-desc mb-10">Helmut F. van Emden | July 2019</div>
                            <div className="book-isbn mb-10">ISBN: 978-1-119-56368-6</div>
                            <div className="book-type mb-10">E-Book</div>
                            <div className="book-instock mb-10">In Stock</div>
                          </div>
                        </div> */}
                        <div className="order-summary">
                          <div className="order-row">
                            <div className="order-col">
                              <label>Subtotal(1 items)</label>
                              <div>Shipping and Tax included</div>
                            </div>
                            <div className="order-col">
                              <label>{checkoutParam.amount} {checkoutParam.presentmentCurrency}</label>
                            </div>
                          </div>
                          <div className="order-row total">
                            <div className="order-col total">
                              <label>Order Total:</label>
                            </div>
                            <div className="order-col total">
                              <label>{checkoutParam.amount} {checkoutParam.presentmentCurrency}</label>
                            </div>
                          </div>

                          {!showPaymentMethod ? (
                            <>
                              <div className="order-row">
                                <div className="order-col">
                                  <button className="btn btn-primary w-100" onClick={handleSubmit}>Proceed to Pay</button>
                                </div>
                              </div>
                              {errorMsg && (
                                <div className="order-row">
                                  <div className="order-col">
                                    <textarea id="errMsgextarea" spellCheck="false" style={{ width: "100%", height: "150px" }} value={errorMsg} readOnly={true}></textarea>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : null}
                        </div>
                        {showPaymentMethod && (
                          <div>
                            <p>Do you want to update Amount?</p>
                            <div className="updateAmount">
                              <input type="text" className="form-control" onChange={changeAmount} value={updateAmountVal}></input>
                              <button className="btn btn-primary" onClick={updateAmount}>Update Amount</button>
                              <div>{updateResText}</div>
                            </div>
                          </div>
                        )}
                        {(selectedPaymentMethod === "Card") && (<div id="address-controller">
                          <label>
                            Hide the billing Address:
                            <input type="checkbox" style={{position: "relative", top: "2px", left: "2px"}}
                              onChange={showBillingAddressHandler}/>
                          </label>
                        </div>)}
                        <div id="error-response-div"></div>
                      </div>
                    </>
                  )}
                {!showPaymentMethod ?
                  null
                  : (<div className="payment-method">
                    <h2>Payment Method</h2>

                    <div>
                      <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="ExpressElement" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          Express Element
                        </label>
                      </div>
                      <div className="paypal-section">
                        <div id="ExpressElementSection">
                          <div id="express-element">
                            {/* A Stripe Express Element will be inserted here.  */}
                          </div>
                        </div>
                      </div>
                      {showPayPal && (
                        <div>
                          <div className="paypal-section">
                            <label className="paypal-label">
                              <input type="radio" value="PayPal" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                              <img src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png" border="0" alt="PayPal Logo" />
                            </label>
                          </div>
                          <div className="paypal-section" id="PayPalSection">
                            {(selectedPaymentMethod === 'PayPal') && (
                              <h5>You will be redirected to the PayPal website to securely complete your order.</h5>
                            )}
                            <div id="paypal-button"></div>
                          </div>
                        </div>
                      )}
                      <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="Card" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          Credit / Debit
                        </label>
                      </div>
                      <div id="CardSection" className={`${(selectedPaymentMethod === "Card") ? "paypal-section cardSelected" : "paypal-section"}`}>
                        <div id="payment-element">
                          {/* Stripe.js injects the Payment Element */}
                        </div>
                        <div id="captchaSection"></div>
                        {(selectedPaymentMethod === "Card") && (
                          <div id="cardBillingAddress">

                            <div className="form-group">
                              <div className="control-label">
                                Billing Country
                              </div>
                              <div className="col-sm-5">
                                <select className="form-control" id="card_billingaddress_country" name="card_billingaddress_country" value={cardBillingAddress.card_billingaddress_country} onChange={changeBillingCountry}>
                                  {countries}
                                </select>
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                Address Line 1
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" name="card_billingaddress_addressLine1" id="card_billingaddress_addressLine1" value={cardBillingAddress.card_billingaddress_addressLine1} onChange={changeAddressLine1} />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                Address Line 2
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" name="card_billingaddress_addressLine2" id="card_billingaddress_addressLine2" value={cardBillingAddress.card_billingaddress_addressLine2} onChange={changeAddressLine2} />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                Postal Code / Postcode / ZIP Code
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" name="card_billingaddress_postCode" id="card_billingaddress_postCode" value={cardBillingAddress.card_billingaddress_postCode} onChange={changeZip} />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                City / Town
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" id="card_billingaddress_city" name="card_billingaddress_city" value={cardBillingAddress.card_billingaddress_city} onChange={changeCity} />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                State / Province / Region
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" name="card_billingaddress_state" id="card_billingaddress_state" value={cardBillingAddress.card_billingaddress_state} onChange={changeState} />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="control-label">
                                Phone Number
                              </div>
                              <div className="col-sm-5">
                                <input type="text" className="form-control" name="card_billingaddress_phone" id="card_billingaddress_phone" value={cardBillingAddress.card_billingaddress_phone} onChange={changePhone} />
                              </div>
                            </div>
                          </div>
                        )}

                        <button id="btn-payment-element-submit" disabled={!canSubmit} className="hide" onClick={submitCardPayment}>
                          Submit
                        </button>
                      </div>
                      {/* <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="Wallet" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          Wallet
                        </label>
                      </div>
                      <div id="WalletSection">
                        <div id="payment-request-button">
                          {`A Stripe Element will be inserted here. --> comment`}
                        </div>
                      </div> */}
                      <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="ACH" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          ACH
                        </label>
                      </div>
                      <div id="ACHSection">
                        <div id="us_bank_account">
                          {/* A Stripe Element will be inserted here.  */}
                        </div>
                        <button id="btn-us-bank-account-submit" className="hide">
                          Submit
                        </button>
                      </div>
                      <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="BACS" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          BACS
                        </label>
                      </div>
                      <div id="BACSSection">
                        <div id="bacs_debit">
                          {/* A Stripe Element will be inserted here.  */}
                        </div>
                        <button id="btn-bacs-debit-submit" className="hide">
                          Submit
                        </button>
                      </div>
                      <div className="paypal-section">
                        <label className="paypal-label">
                          <input type="radio" value="BECS" name="radioPaymentMethod" onChange={onPaymentMethodChange}></input>
                          BECS
                        </label>
                      </div>
                      <div id="BECSSection">
                        <div id="au_becs_debit">
                          {/* A Stripe Element will be inserted here.  */}
                        </div>
                        <button id="btn-au-becs-debit-submit" className="hide">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                  )}
              </div>
            </div>
          </div>
          <div className="loader-div">
            <span className={`loader ${isLoading ? "loading" : ""}`}><LoaderComp /></span>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckoutPayment;